import { render } from "./CustomElement.vue?vue&type=template&id=0241148e"
import script from "./CustomElement.vue?vue&type=script&lang=js"
export * from "./CustomElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__